var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-toolbar",
    [
      !_vm.$wf.isSmDown
        ? [
            _vm.toolbarIframeUrl
              ? _c("iframe", {
                  staticClass: "toolbar-iframe",
                  style: _vm.toolbarIframeStyle,
                  attrs: { src: _vm.toolbarIframeUrl, frameborder: "0" },
                })
              : _vm._e(),
            _c(
              "app-toolbar-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct("tooltip.prev-bookyear"),
                    expression: "$ct('tooltip.prev-bookyear')",
                  },
                ],
                style: { marginRight: 0, padding: "0 10px 0 8px" },
                attrs: { disabled: !_vm.showPreviousBookYearButton },
                on: {
                  click: function ($event) {
                    return _vm.selectPreviousBookyear()
                  },
                },
              },
              [_c("w-fa", { attrs: { icon: "angle-left" } })],
              1
            ),
            _c(
              "app-toolbar-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct("tooltip.change-bookyear"),
                    expression: "$ct('tooltip.change-bookyear')",
                  },
                ],
                style: { marginLeft: "5px", marginRight: "5px" },
                on: { click: _vm.changeBookYear },
              },
              [_c("span", [_vm._v(_vm._s(_vm.currentBookYear))])]
            ),
            _c(
              "app-toolbar-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct("tooltip.next-bookyear"),
                    expression: "$ct('tooltip.next-bookyear')",
                  },
                ],
                style: { marginLeft: 0, padding: "0 8px 0 10px" },
                attrs: { disabled: !_vm.showNextBookYearButton },
                on: {
                  click: function ($event) {
                    return _vm.selectNextBookyear()
                  },
                },
              },
              [_c("w-fa", { attrs: { icon: "angle-right" } })],
              1
            ),
            _vm.showReferralGift ? _c("app-referral-gift-dropdown") : _vm._e(),
            _c(
              "app-toolbar-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct("tooltip.notifications"),
                    expression: "$ct('tooltip.notifications')",
                  },
                ],
                style: { position: "relative" },
                on: {
                  click: function ($event) {
                    _vm.notificationModal = true
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "icon nav-icon icon-bell2",
                  class: { "icon-bell-ringing2": _vm.pendingNotifications },
                }),
                _vm.pendingNotifications
                  ? _c("div", { staticClass: "notifications-ball" })
                  : _vm._e(),
              ]
            ),
            _c(
              "app-toolbar-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.$ct("tooltip.support"),
                    expression: "$ct('tooltip.support')",
                  },
                ],
                staticClass: "mr support",
                style: {
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  marginRight: "10px",
                },
                attrs: { to: "/support" },
              },
              [
                _c("span", { staticClass: "icon nav-icon icon-support mr" }),
                _c("div", [_vm._v(_vm._s(_vm.$ct("support")))]),
              ]
            ),
          ]
        : _c(
            "w-toolbar-select",
            {
              attrs: { "hide-arrow": "", right: "", items: _vm.toolbarItems },
              on: {
                click: function ($event) {
                  return _vm.trigger($event)
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "ellipsis-v" } }),
              _vm.pendingNotifications
                ? _c("div", { staticClass: "notifications-ball" })
                : _vm._e(),
            ],
            1
          ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.changeBookYearModal,
            callback: function ($$v) {
              _vm.changeBookYearModal = $$v
            },
            expression: "changeBookYearModal",
          },
        },
        [
          _c("app-select-book-year", {
            on: {
              close: function ($event) {
                _vm.changeBookYearModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "", top: "" },
          model: {
            value: _vm.notificationModal,
            callback: function ($$v) {
              _vm.notificationModal = $$v
            },
            expression: "notificationModal",
          },
        },
        [
          _c("app-notifications-modal", {
            on: {
              close: function ($event) {
                _vm.notificationModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.changeDossierModal,
            callback: function ($$v) {
              _vm.changeDossierModal = $$v
            },
            expression: "changeDossierModal",
          },
        },
        [
          _c("app-select-dossier", {
            on: {
              close: function ($event) {
                _vm.changeDossierModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }